import { render, staticRenderFns } from "./SimpleMainTable.vue?vue&type=template&id=f4651c00&scoped=true"
import script from "./SimpleMainTable.vue?vue&type=script&lang=js"
export * from "./SimpleMainTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4651c00",
  null
  
)

export default component.exports